// Псевдоним пациента (patients.alias) — задаётся перед обследованием/в карточке и печатается в отчёте
// вместо имени. В интерфейсе основным остаётся настоящее имя, псевдоним — мелко рядом с ним.
export function patientReportName(patient) {
  return patient?.alias?.trim() || patient?.name || "";
}

export default function PatientAlias({ name, alias, className = "" }) {
  const value = alias?.trim();
  if (!value || value === name?.trim()) return null;
  return (
    <span className={`text-[10px] font-normal text-slate-400 ml-1 ${className}`} title="Псевдоним — печатается в отчёте вместо имени">
      ({value})
    </span>
  );
}
